import { UserRoles } from '@lifeserver/shared';

import { useUserProfile } from './useUserProfile';

export function useIsAuthorized(role: UserRoles) {
    const { data: user, isLoading } = useUserProfile();

    return {
        isAuthorized: user?.roles.includes(role),
        isLoading,
    };
}
